<template>
	<ul :class="['formulario-theme1','formulario-bg-white', {'divider': divider}]" v-if="estructura && estructura.length">
        <li 
        v-for="(data, i) in estructura"
        :key="i"
        :class="[
            {'divider' : data.find(d => !d.attr.hasOwnProperty('divider') || (d.attr.hasOwnProperty('divider') && d.attr.divider))}, 
            estructura[i].some(e => ['editable','readonly','read-only'].includes(e.state)) ? 'visible' : 'no-visible',
            `label-${data[0].labelposition || 'left'}`,
            {hidden: data.every(s => !s.visible)}]">
            
            <div v-if="(porlet && porlet.attr && !porlet.attr['label-position']) || (porlet.tipo === 'porlet' && porlet.attr && porlet.attr['label-position'] !== 'top') || !porlet.attr"
                :class="[
                    'form-label',
                    'ellipsis',
                    { 'center': !estructura[i][0].subtitle },
                    { 'visible-label': visibleLabel }
                ]">

                <template v-if="i > 0 && estructura[i-1][0].attr.hasOwnProperty('divider') ? estructura[i-1][0].attr.divider : true">
                    <p class="ellipsis">
                        
                        <!-- campo simple -->
                        <template v-if="estructura[i][0].title && estructura[i][0].attr.divider == true">
                            <span class="title" :title="estructura[i][0].title">{{estructura[i][0].title}}</span>
                        </template>
                        <!-- campo compuesto -->
                        <template v-else>
                            <span class="title" :title="getUnionTitle(estructura[i])">{{getUnionTitle(estructura[i])}}</span>
                        </template>
                        
                        <span class="title-alt" v-if="estructura[i][0].title2" :title="estructura[i][0].title2">{{estructura[i][0].title2}}</span>
                    </p>
                    <span class="subtitle" v-if="estructura[i][0].subtitle" :title="estructura[i][0].subtitle">{{estructura[i][0].subtitle}}</span>
                </template>
                <template v-else>
                    <p class="ellipsis">
                        <span class="title-alt" v-if="data.some(p => p.title2)" :title="unionProps(data)">{{unionProps(data)}}</span>
                        <span class="title" v-else :title="data[0].title">{{getUnionTitle(estructura[i])}}</span>
                    </p>
                    <span class="subtitle"></span>
                </template>

                <!-- filtros para buscador -->
                <div v-if="filter_search(data)">
                    <el-select 
                    :value="objects.find(f => f.key == `${data[0].key}_filter`).value" 
                    placeholder="Selecciona" 
                    size="small" 
                    @change="val => $emit('input', {newvalue: val, input: {key: filter_search(data).key}})">
                        <el-option
                        v-for="option in filter_search(data).options"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
           
            <div :class="['form-input', {'label-top': porlet && porlet.attr && porlet.attr['label-position'] === 'top'}]">
                <el-row :gutter="0">
                    <el-col  
                    v-for="(input,inpuntIndex) in data"
                    :key="inpuntIndex"
                    :span="input.attr.hasOwnProperty('col') ? input.attr.col : 24"
                    :style="{'height': input.format == 'textarea' ? 'fit-content' : 'auto'}">
                        <div class="actions" v-loading="input.loading" :ref="`formgroup_${i}_${inpuntIndex}`">
                            <p class="label-top">
                                {{input.title}}
                            </p>
                            <InputSigarus
                                :busy.sync="input.loading"
                                v-show="input.hasOwnProperty('visible') && input.visible"
                                :identificador="id"
                                :entidad="entidad"
                                :siblings="inputList"
                                ref="input"
                                :input="input"
                                :saveUrl="autosave ? `${apiUrl.backend}input` : ''"
                                :type="input.format.includes('numeric') ? 'number' : input.format"
                                :obligatorio="!!input.obligatorio"
                                :value="formatValue(input)"
                                :placeholder="input.placeholder"
                                :readonly="(isExtraType(input) && ['id'].includes(isExtraType(input)) ? true : input.state == 'read-only') || (input.state == 'read-only')"
                                :textPre="input.textpre"
                                :textPos="input.textpos"
                                :options="input.options"
                                @input="val => emitInput(val,input)"
                                @id="input => $emit('setActionId', input)"
                                @go="inputGo"
                                @saved="val => $emit('saved', val)"
                                @obligatorio="foc(`formgroup_${i}_${inpuntIndex}`, ['actions obligatorio'])"
                                @blur="blur(`formgroup_${i}_${inpuntIndex}`, ['actions'])"
                                />

                                <el-tooltip 
                                v-for="(action, actionIndex) in actionsByInput(input)"
                                :key="actionIndex"
                                class="item" 
                                effect="dark" 
                                :content="action ? action.titulo : ''" 
                                placement="top">
                                    <el-button
                                    v-if="action"
                                    @click="porlet.events.clickAction(action)"
                                    type="default" 
                                    size="small" 
                                    :icon="action.icon"
                                    />
                                </el-tooltip>

                        </div>
                    </el-col>
                </el-row>
            </div>    

        </li>
    </ul>
</template>

<script>
    import InputSigarus from '@/components/inputs/InputSigarus.vue'
    
    import { mapState } from 'vuex'
    import { getUrl } from '@/helpers/api'

    import moment from 'moment'

	export default {
        name: 'Formulario',
        components: {
            InputSigarus
        },
		props: {
            ficha: {
                type: Object,
                required: false,
                default: () => null
            },
            entidad: String,
            url: {
                type: Object,
                required: false,
                default: () => null
            },
            objects: {
                type: Array,
                required: false,
                default: () => null
            },
            id: [Number,String],
            autosave: {
                type: Boolean,
                required: false,
                default: () => true
            },
            divider: {
				type: Boolean,
				required: false,
				default: () => true
            },
            focus: {
				type: Boolean,
				required: false,
				default: () => false
            },
            inputList: Array,
            visibleLabel: {
                type: Boolean,
                required: false,
                default: () => true
            },
            porlet: {
                type: Object
            }
        },
		data () {
            return {
                moment,
                apiUrl: '',
                estructura: null,
                currentAction: null,
                fichaInicial: null,
                formularioInicial: null,
                loading: false,
                inputsTypeGoId: ['id','go','botongo','botonid']
            }
        },
        computed: {
            ...mapState({
                config: state => state.config.data
            })
        },
        watch: {
            objects: {
                handler() {
                    this.init()
                },
                deep: true
            },
            estructura() {
                this.$nextTick(() => {
                    if (this.$refs.input) {
                        this.$emit('refsInputs', this.$refs.input.filter(input => !['hidden:id'].includes(input.type) && !input.readonly && !input.visible ))
                    }
                })
            }
        },
        mounted() {
            this.init()
            this.$emit('created')
        },
        methods: {

            foc(key, style) {
                this.$refs[key][0].classList.value = style
            },
            
            blur(key, style) {
                this.$refs[key][0].classList.value = style
            },
            
            init () {

                this.apiUrl = getUrl()

                // Si hay url realizamos peticion de lo contrario creamos estructura con los objetos que puedan llegar
                if (this.url) {

                    this.loading = true

                    try {

                        // Hacer merge de peticiones, la de por defecto y la final con lo que hay que pintar definitivamente
                        // ## FALTA POR METER PETICION A URL EXTERNA PARA OBTENER FORMULARIO
                        this.fichaInicial = form
                        this.formularioInicial = Object.keys(form.data).map(key => {
                            const el = form.data[key]
                            return (typeof el == 'object') ? el : ''
                        }).filter(el => el !== '')

                    } catch (e) {
                        console.log('Error init :: ',e)
                    }

                    this.loading = false

                } else if (this.objects) {
                    
                    this.fichaInicial = this.ficha
                    this.formularioInicial = this.objects
                }

                this.crearEstructura()

                /*let _self = this
                setTimeout(() => {
                    //_self.createInputList() // Crea un listado de los input del formulario

                    if (_self.focus && _self.inputList && _self.inputList.length) { // primer elemento del formulario editable
                        _self.inputList[0].editing = true
                    }
                },100)*/

                

            },

            crearEstructura() {

                const salida = []
				let controlKey = 0
                
				this.formularioInicial.forEach((object, i) => {
					if(controlKey == 0 || ( controlKey < i )) { 

						const array = []
						if(!object.attr.hasOwnProperty('divider') || ( object.attr.hasOwnProperty('divider') && object.attr.divider)) {
							array.push(this.formularioInicial[controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + i : (i + 1) )]) // Hay divider, termina la fila
							controlKey = 0
						} else {

							let totalCol = 0 //Acumula el ancho de cada columna por fila recorrida
                            
							while(totalCol < 24) { // Comprueba si hay hueco para meter mas campos

								controlKey = controlKey > 0 ? controlKey + 1 : ( controlKey == 0 ? controlKey + (((totalCol>0 && totalCol<24) && i==0 )?i+1 : i) : (i + 1) ) // Almaceno el siguiente indice a recorrer
                                if(this.formularioInicial[controlKey]) {
                                    const currentCol = (this.formularioInicial[controlKey].attr.col || 24)
                                    if((totalCol + currentCol) <= 24) { // Comprobar limite de columnas para cada fila
                                        
                                        array.push(this.formularioInicial[controlKey])
                                        totalCol = totalCol + currentCol
                                        
                                    } else {
                                        totalCol = 24
                                        controlKey = controlKey - 1
                                    }
                                } else {
                                    totalCol = 24
                                }
								
							}
						}

						salida.push(array)

					} else if (controlKey == i) {
						controlKey = 0
					}
				})

                this.estructura = salida
                
            },

            getUnionTitle(estructura) {
                // Para campos que esten en la misma fila y deban concatenar los titulos
                let out = estructura.reduce((acum, val) => {
                    if(!acum.includes(val.title)) acum.push(val.title)
                    return acum
                },[])

                return out.join(' / ')
            },
			
			// Unir propiedades dentro del mismo array Ej: CP/PAIS/PROVINCIA
			unionProps(data) {
				return data.reduce((a,d) => {
					if(d.title && !a.includes(d.title)) {
						a.push(d.title)
					}
					return a
				},[]).join(' / ')
            },

            // Comprobar si es de tipo id o go
            isExtraType (input) {

				const types = input.format.split(':')

				if (types.length < 2) return false

				return types[1]

			},

            inputGo(input) {

                if(!input.value) return

                this.$emit('openWindow', {
					entidad: input.entidad, 
					id: input.value
				})
            },

            filter_search(data) {
                
                let obj = false

                if (data[0].title) {
                    
                    let key = `${data[0].key}_filter`
                    let obj_filter = this.objects.find(f => f.key == key)
                    if (obj_filter) {
                        obj = {
                            options: obj_filter.options,
                            value: obj_filter.options[0].value,
                            key
                        }
                    }
                }
                
                return obj
            },

            actionsByInput (input) {

                let items = []
                let _self = this
                if (input && input.actions && input.actions.length && _self.fichaInicial.actions) {
                    items = Object.values(input.actions)
                    .filter(action => action != "")
                    .map(accion => {
                        let m = _self.fichaInicial.actions[accion]
                        if (!m) return

                        return {
                            icon: m.icon,
                            titulo: m.titulo,
                            auto: m.auto || true,
                            function: m.function || null,
                            metodo: m.metodo || null,
                            url: m.url ? m.url.replace('@@id@@',_self.id) : null
                        }
                    })
                }
                return items

            },

            // Formatear value
            formatValue(input) {

                

                let val = input.value

                if (input.format == 'datepicker') {

                    if (['0000-00-00',null,'',undefined].includes(val)) {
                        val = ''
                    } else {
                        val = moment(val,'YYYY-MM-DD').format('DD/MM/yyyy')
                    }

                } else if (input.format == 'datetimepicker') {

                    if (['0000-00-00',null,'',undefined].includes(val)) {
                        val = ''
                    } else {
                        val = moment(val,'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
                    }
                }

                return val
            },
            emitInput(val, input) {

                console.log('emitInput', val, input)

                let newvalue = val

                if(input.format == 'datepicker') {

                    newvalue = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')

                } else if(input.format == 'datetimepicker') {

                    newvalue = moment(val, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
                }

                this.$emit('input', {newvalue, input})
            }
        }
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

form {
    width: 100%;
}

ul.formulario-theme1 {
    padding: 0px;
    margin: 0px;
    list-style: none;
    background-color: $--color-surface;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    border-radius: 6px;
    border-top: 1px solid #e9e9eb!important;
    border-radius: 0px!important;
    &.divider {
        li{
            padding: 0rem;
            &.divider {
                border-bottom: 1px solid rgb(233, 233, 235);
            }
            &:last-child {
                border: 0px!important;
            }
        }
    }
    li {
        padding: 0.4rem 0rem;
        flex-flow: row;
        &.no-visible,
        &.hidden {
            display: none!important;
        }
        &.visible {
            display: flex;
        }
        &.label-top {
            flex-flow: column;
            .form-label {
                width: 100%!important;
            }
        }
        &.label-left {
            flex-flow: row;
        }
        &.label-bottom {
            flex-flow: column-reverse;
        }
        &.label-right {
            flex-flow: row-reverse;
        }
        
        .form-label {
            width: 150px;
            flex-shrink: 0;
            display: none;
            padding: 0rem 0.50rem;
            color: #0000009c;
            border-right: 1px solid #e9e9eb;
            background-color: $--color-surface-soft;

            &.center {
                align-items: center;
            }
            &.visible-label {
                display: flex;
            }
            p {
                font-size: .8rem;
                margin: 0px;
                color: black;
                .title-alt {
                    color: #4a596ab3;
                    margin-left: 0.3rem;
                    &:first-child {
                        margin-left: 1rem;
                    }
                }
            }
            span {
                &.subtitle {
                    font-size: 0.7rem;
                    color: #4a596a;
                }
            }
        }
        .form-input {
            flex-grow: 1;
            .el-col {
                &.height-fit {
                    height: fit-content!important;
                }
            }
            > button {
                margin: 1px 1px;
                border-radius: 0px;
                padding: 8px 9px;
                max-height: 30px;
                max-width: 30px;
            }

            // Label top
            .actions {
                p.label-top { display: none; }

            }
            &.label-top {
                .el-col {
                    border-right: 1px solid #e9e9eb;
                    .actions {
                        flex-direction: column;
                        p.label-top {
                            display: block;
                            text-align: left;
                            margin: 0px;
                            width: -webkit-fill-available;
                            padding: 0.4rem 0.50rem;
                            color: #0000009c;
                            background-color: $--color-surface-soft;
                            font-size: .8rem;
                        }
                    }
                }
            }
        }
        .actions {
            display: flex;
            height: auto;
            align-items: center;
            min-height: auto!important;
            .actions-content {
                display: flex;
                flex-grow: 1;
                .action-button {
                    padding: 0px;
                    margin-left: 2px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: $--color-surface;
                    color: #4a596a;
                    border: 1px solid #e4e7ed;
                    padding: 0px;
                    margin-left: 2px;
                    border-radius: 3px;
                    height: 28px;
                    width: 28px;
                    font-size: 13px;
                    cursor: pointer;
                    width: -webkit-fill-available;
                }
            }
            &.obligatorio {
                background-color: rgb(253, 226, 226);
            }
        }
    }
}

.placeholder {
    color: rgb(187, 187, 187);
}
</style>